import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FooterLayout from '../../containers/Footer';
import HeaderLayoutComponent from '../../containers/Header';
import CookiesLayout from '../../containers/Coockies';
import MainViewComponent from '../Main/MainView';
import SpinnerWaitLoadingData from '../../containers/SpinnerWaitLoadingData'
import classNames from 'classnames';

import '../../assets/styles/style.scss';

class AppComponent extends Component {
  render() {
    return (
      //  className app--cart-modal needed to disable app scrolling when cart modal opened
      <div className={
        classNames('app', {
          'app--cart-modal': this.props.openedBasket
        })}>
        <HeaderLayoutComponent />
        <MainViewComponent />
        <FooterLayout />
        <CookiesLayout />
        <SpinnerWaitLoadingData />
      </div>
    );
  }
}

AppComponent.propTypes = {
  openedBasket: PropTypes.bool,
};

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/App/App.js